"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const noop_1 = __importDefault(require("lodash/noop"));
const prop_types_1 = __importDefault(require("prop-types"));
const html_sanitizer_1 = require("../../utils/html-sanitizer");
const modal_1 = __importDefault(require("../modal/modal/modal"));
require("../../styles/components/video-player-modal.less");
const VideoPlayerModal = ({ isOpen, onCloseModal, videoUrl }) => {
    const safeUrl = (0, react_1.useMemo)(() => (0, html_sanitizer_1.sanitizeString)(videoUrl), [videoUrl]);
    return (react_1.default.createElement(modal_1.default, { isOpen: isOpen, className: "video-modal", hideHeader: true, hideFooter: true, closeModal: onCloseModal, showCancel: false, message: (react_1.default.createElement("div", { className: "video-wrapper" },
            react_1.default.createElement("iframe", { id: "totango-vimeo-video", sandbox: "allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox", src: `${safeUrl}&autoplay=1`, title: "video-iframe", allow: "autoplay", frameBorder: "0", height: "100%", width: "100%", className: "video-iframe" }))) }));
};
VideoPlayerModal.defaultProps = {
    onCloseModal: noop_1.default,
};
VideoPlayerModal.propTypes = {
    isOpen: prop_types_1.default.bool.isRequired,
    videoUrl: prop_types_1.default.string.isRequired,
    onCloseModal: prop_types_1.default.func,
};
exports.default = VideoPlayerModal;
//# sourceMappingURL=video-player-modal.js.map